export default __webpack_public_path__ + "static/media/edit-white.a899a8e9.svg";